var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSmiley = function SvgSmiley(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.818,
    height: 11.818,
    viewBox: "0 0 11.818 11.818",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "smiley",
    d: "M88.066,181.126a.794.794,0,1,0-.565-.233A.769.769,0,0,0,88.066,181.126Zm-4.314,0a.794.794,0,1,0-.565-.233A.769.769,0,0,0,83.752,181.126Zm2.157,4.018a3.265,3.265,0,0,0,1.795-.524,3.008,3.008,0,0,0,1.189-1.426h-.768a2.326,2.326,0,0,1-.931.908,2.657,2.657,0,0,1-1.278.318,2.751,2.751,0,0,1-1.285-.31,2.153,2.153,0,0,1-.923-.916h-.783a3.108,3.108,0,0,0,1.2,1.426A3.229,3.229,0,0,0,85.909,185.144Zm0,2.674a5.754,5.754,0,0,1-2.3-.465,5.9,5.9,0,0,1-3.139-3.139,5.939,5.939,0,0,1,0-4.609,5.9,5.9,0,0,1,3.139-3.139,5.939,5.939,0,0,1,4.609,0,5.9,5.9,0,0,1,3.139,3.139,5.939,5.939,0,0,1,0,4.609,5.9,5.9,0,0,1-3.139,3.139A5.754,5.754,0,0,1,85.909,187.818ZM85.909,181.909Zm0,5.023a4.984,4.984,0,1,0-3.563-1.46A4.848,4.848,0,0,0,85.909,186.932Z",
    transform: "translate(-80 -176)",
    fill: "#28ad56"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmiley, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smiley.5a88e452.svg";
export { ForwardRef as ReactComponent };